import axios from "axios";

function resolveApiBaseURL() {
  const envUrl = (process.env.REACT_APP_API_URL || "").trim();
  if (envUrl) return envUrl;

  if (typeof window === "undefined") {
    return "http://localhost:8080";
  }

  const host = String(window.location.hostname || "").toLowerCase();
  const isLocal =
    host === "localhost" ||
    host === "127.0.0.1" ||
    host === "0.0.0.0";

  return isLocal ? "http://localhost:8080" : window.location.origin;
}

const apiBaseURL = resolveApiBaseURL();

const httpClient = axios.create({
  baseURL: apiBaseURL,
  withCredentials: true,
});

httpClient.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

export default httpClient;
